// extracted by mini-css-extract-plugin
export default {"checkboxItem":"Checkbox_checkboxItem__f+bJR","checkboxItem_checkbox":"Checkbox_checkboxItem_checkbox__5PJIP","checkboxItem_label":"Checkbox_checkboxItem_label__rc4Jd"};